import { render, staticRenderFns } from "./customer-service.vue?vue&type=template&id=d9a527bc&scoped=true&"
import script from "./customer-service.vue?vue&type=script&lang=js&"
export * from "./customer-service.vue?vue&type=script&lang=js&"
import style0 from "./customer-service.vue?vue&type=style&index=0&id=d9a527bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a527bc",
  null
  
)

export default component.exports